<template>
    <div :class="[
        'highlight-block',
        {
            image: hasImage
        }
    ]">
        <div class="highlight-gabarit">
            <div class="baseline main-baseline">
                <div class="text" v-html="layout.baseline"/>
            </div>
            <div class="cover">
                <div class="baseline text" v-html="layout.baseline"/>
            </div>
            <div
                class="description"
            >
                <div
                    class="text"
                    v-html="layout.description"
                />
                <router-link
                    v-if="hasCta"
                    :to="$trl({name: layout.cta.link})"
                >
                    <Cta class="cta">
                        {{layout.cta.caption}}
                    </Cta>
                </router-link>
            </div>
        </div>
        <img
            v-if="hasImage"
            :src="layout.image.image"
        />
    </div>
</template>

<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        hasImage() {
            return this.layout.image && this.layout.image.display
        },
        hasCta() {
            return this.layout.cta && this.layout.cta.display
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.highlight-block
    position: relative
    @media print
        // page-break-before: always
        // break-before: page
        page-break-inside: avoid
        break-inside: avoid

.highlight-gabarit
    display: flex
    overflow: hidden
    position: relative
    @include media-breakpoint-down($lg)
        display: block
        padding-left: 72 / 750 * 100%
        padding-right: 72 / 750 * 100%
        background-color: #ff2b2a
        padding-bottom: 4.25%
    @include media-breakpoint-down($sm)
        padding-top: 12%
        padding-bottom: 12%
    /deep/ h1
        color: #ff2b2a
        margin: 0

    /deep/ h2
        padding-right: 13%
        strong,
        b
            color: #ff2b2a
    /deep/ p
        font-size: 28px
        line-height: 1.4285714286
        letter-spacing: -0.03125em
        color: #ffffff
    /deep/ ul
        list-style: none
        @media print
            list-style: disc
        li
            font-size: 28px
            line-height: 1.4285714286
            letter-spacing: -0.03125em
            color: #ffffff
            position: relative
            &+li
                margin-top: 1.5em
            &::before
                content: ''
                display: inline-block
                height: 1em
                width: 1em
                background-image: url('./../../assets/plus.svg')
                background-size: contain
                background-repeat: no-repeat
                position: absolute
                right: 100%
                margin-right: 1.625em
                top: .5em
.main-baseline
    @include media-breakpoint-down($lg)
        display: none

.cover
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    display: flex
    background-color: #ff2b2a
    overflow: hidden
    transform: translateX(40.625vw)
    @include media-breakpoint-down($lg)
        transform: none
        position: static
    .image &
        transform: translateX(50vw)
        @include media-breakpoint-down($lg)
            transform: none
    .baseline
        transform: translateX(-40.625vw)
        @include media-breakpoint-down($lg)
            transform: none
        .image &
            transform: translateX(-50vw)
            @include media-breakpoint-down($lg)
                transform: none

        // max-width: 65.8333333333%
        // @include media-breakpoint-down($lg)
        //     max-width: 100%
        /deep/ h1,
        /deep/ h2,
        /deep/ h3,
        /deep/ p
            color: #ffffff
img
    width: 100%
    height: auto
    margin-top: -20.3125%
.baseline
    padding-left: 10.41667%
    flex: .7
    padding-top: 6%
    padding-bottom: 6%
    position: relative
    z-index: 0
    max-width: 60%
    padding-right: 5%
    @include media-breakpoint-down($lg)
        max-width: 100%
        padding-top: 20%
        padding-left: 0
        flex: 1
    @include media-breakpoint-down($sm)
        padding-top: 0
        padding-bottom: 0
    @media print
        padding-top: 1.2em
        padding-bottom: .6em
    .image &
        padding-bottom: 11.25%
.description
    flex: .3
    background-color: #ff2b2a
    padding-right: 10.41667%
    // padding-top: 6.25%
    padding-top: 6.25%
    padding-bottom: 6.25%
    position: relative
    z-index: 1
    margin-top: 16px
    @include media-breakpoint-down($lg)
        flex: 1
        .text
            /deep/ ul li
                font-size: 35px
                margin-left: 75px
    @include media-breakpoint-down($md)
        margin-top: 0px
    @include media-breakpoint-down($sm)
        padding-bottom: 0
        .text
            /deep/ ul li
                font-size: 17px
                margin-left: 35px

    @media print
        padding-top: 0
        padding-bottom: 0
        margin-bottom: .6cm
        .text
            /deep/ ul li
                font-size: 17px
                margin-left: 0
.cta
    margin-top: 30%
</style>
